import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMeal} from '../../domain/saved-meal';
import type {SavedMealRepository, UpdateSavedMealInput} from '../ports/saved-meal.repository';

export class UpdateSavedMeal implements UseCase<[UpdateSavedMealInput], SavedMeal> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(input: UpdateSavedMealInput): Promise<Result<SavedMeal, SavedMealError>> {
    return this.repository.update(input);
  }
}
